<app-influencer-view
  [hideClass]="true" [projectId]="projectId"
  [influencerId]="influencerId" [isModal]="true"
  (closeModal)="closeModal()">
</app-influencer-view>
